/* Scroll-in text animation (see assets/text-reveal.css). */
(function () {
  if (window.__textRevealLoaded) return;
  window.__textRevealLoaded = true;
  if (!('IntersectionObserver' in window)) return; // text simply stays visible

  document.documentElement.classList.add('js-reveal');

  // Letter by letter: each word stays together (no mid-word line breaks),
  // each letter is its own span
  function splitChars(el) {
    if (el.__split) return;
    el.__split = true;
    var c = 0;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) return frag.appendChild(document.createTextNode(part));
        var word = document.createElement('span');
        word.className = 'reveal-chars-word';
        Array.from(part).forEach(function (ch) {
          var s = document.createElement('span');
          s.className = 'reveal-char';
          s.style.setProperty('--c', c++);
          s.textContent = ch;
          word.appendChild(s);
        });
        frag.appendChild(word);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  // Wrap each word in a span, keeping links/bold etc. intact
  function splitWords(el) {
    if (el.__split) return;
    el.__split = true;
    var i = 0;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      if (parts.length < 2 && !node.textContent.trim()) return;
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
        } else {
          var span = document.createElement('span');
          span.className = 'reveal-word';
          span.style.setProperty('--w', i++);
          span.textContent = part;
          frag.appendChild(span);
        }
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  // A group starts when its first animated piece (usually the title) is
  // about a third of the way up the screen, not when the panel edge appears
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var group = e.target.__revealGroup || e.target;
      group.classList.add('is-revealed');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -35% 0px', threshold: 0 });

  function init(root) {
    (root || document).querySelectorAll('[data-reveal="words"]').forEach(splitWords);
    (root || document).querySelectorAll('[data-reveal="chars"]').forEach(splitChars);
    (root || document).querySelectorAll('[data-reveal-group]').forEach(function (g) {
      if (g.__revealInit) return;
      g.__revealInit = true;
      var first = g.hasAttribute('data-reveal') ? g : g.querySelector('[data-reveal]');
      var target = first || g;
      target.__revealGroup = g;
      io.observe(target);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: show re-rendered sections right away
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('[data-reveal-group]').forEach(function (g) { g.classList.add('is-revealed'); });
  });
})();
